import './license-compare-modal.css';
